import Vue from 'vue';

import moment from 'moment-jalaali';

import RequestMixin from "./_requestMixin.js";

import {
  EventBus
} from "@/main"

import {
  mapState
} from 'vuex'
import Swal from 'sweetalert2'

Vue.mixin({
  mixins: [RequestMixin],
  data() {
    return {
      token: null,
    }
  },
  computed: {
    EventBus() {
      return EventBus;
    },
    ...mapState({
      appId: state => state.appId,
      user: state => state.user,
      systemOptions: state => state.options,
      OGR: state => state.OGR,
      serverNow: state => state.serverNow,
      isPrinting: state => state.isPrinting
    }),
    isDev() {
      return process.env.NODE_ENV === 'development';
    },
    urlQuery() {
      return this.$route.query;
    },
    isXs() {
      return (window.innerWidth <= 600)
    },
    isSm() {
      return (window.innerWidth >= 600 && window.innerWidth < 960)
    },
    isMd() {
      return (window.innerWidth >= 960 && window.innerWidth < 1264)
    },

  },
  created() {
    this.token = localStorage.getItem('token');
    // On a hard/cold load straight to a deep link (exactly how a PWA opens from
    // a home-screen icon), the very first component's created() can fire before
    // Vue Router has resolved the initial route at all — $route briefly reports
    // matched=[] / name=null regardless of the real URL. Only act once the router
    // has actually matched something, otherwise this fires on that transient
    // unresolved state and bounces to Login before the real route ever gets a
    // chance to match (confirmed via logging: route=null fullPath=/ on first fire).
    const routeResolved = this.$route && this.$route.matched && this.$route.matched.length;
    // PackingEntry (the mobile packing PWA) handles its own inline login instead
    // of bouncing out to the separate desktop Login page — see PackingEntryView.vue.
    if (!this.token && routeResolved && !['Login', 'PackingEntry'].includes(
      this.$route.name)) {
      this.$router.push({
        name: 'Login'
      });
    }
  },
  mounted() { },
  methods: {
    setDocumentTitle(title) {
      if (!title) title = "پنل | سوپر اپلیکیشن اکسونی"
      document.title = ` ${title} |  سوپر اپلیکیشن اکسونی`
      return ` ${title} |  سوپر اپلیکیشن اکسونی`;
    },
    tabEmit(eventName, data = null) {
      let broadcastChannel = new BroadcastChannel(eventName)
      broadcastChannel.postMessage({
        appId: this.appId,
        data: data
      })
    },
    tabOn(eventName, handler) {
      let broadcastChannel = new BroadcastChannel(eventName)
      broadcastChannel.onmessage = (message) => handler(message.data)
    },

    canGet(name) {
      let flag = this.$store.state.isGetting[name]
      if (!flag) {
        this.toggleIsGetting(name)
      }
      return !flag;
    },
    toggleIsGetting(name) {
      let state = this.$store.state.isGetting[name]
      let newState = {}
      newState[name] = !state
      this.$store.commit('updateIsGetting', newState)
    },
    downloadUrl(url) {
      let element = document.createElement("a");
      element.href = url;
      element.target = "_blank";
      element.rel = "noopener noreferrer";
      element.click();
      element.remove();
    },
    newTab(to) {
      let routeData = this.$router.resolve(to);
      window.open(routeData.href, '_blank');
    },
    getOptionValue(codename) {
      return this.systemOptions.filter(o => o.codename == codename)[0].value;
    },

    askConfirmations(confirmations) {
      /*
      # Structure
      confirmation = {
        text: '',
      }
      */

      for (const confirmation of confirmations) {
        let confirmed = confirm(confirmation.text);
        if (!confirmed) return false;
      }

      return true

    },
    initTooltips() {
      $(function () {
        $('[data-toggle="tooltip"]').tooltip()
      })
    },
    extractIds(data, exclude = []) {
      let res = this.copy(data);
      Object.keys(res).forEach(key => {
        if (exclude && exclude.length && exclude.includes(key)) return;
        if (res[key] && (typeof (res[key]) == 'object' && 'id' in res[key])) res[key] = res[key].id;
      });
      return res;
    },
    successNotify(message) {
      let text = "ثبت با موفقیت انجام شد"
      if (message) {
        text = message
      }
      Swal.fire({
        title: " ثبت مـوفق",
        text: text,
        icon: "success",
        confirmButtonText: "ادامه",
        confirmButtonColor: '#009c31',
        background: 'rgba(8, 194, 67, 0.7)',
        color: '#fff',
        width: '32rem',
        iconColor: 'rgba(255, 255, 255, 0.9)',
        customClass: {
          title: 'my-title-font',
          htmlContainer: 'my-text-font',
          confirmButton: 'my-button-font'
        },
        didOpen: () => {
          const popup = Swal.getPopup();
          popup.style.setProperty('--swal2-font-family', 'IRANSans', 'important');
          popup.querySelector('.swal2-title').style.fontFamily = 'IRANSans';
          popup.querySelector('.swal2-html-container').style.fontFamily = 'IRANSans';
          popup.querySelector('.swal2-confirm').style.fontFamily = 'IRANSans';
        }

      });

    },
    editNotify(message) {
      let text = "ویرایش با موفقیت انجام شد"
      if (message) {
        text = message
      }
      Swal.fire({
        title: " ویرایش مـوفق",
        text: text,
        icon: "success",
        confirmButtonText: "ادامه",
        confirmButtonColor: '#FD6B4B',
        background: 'rgba(241, 115, 89, 0.7)',
        color: '#fff',
        width: '32rem',
        iconColor: 'rgba(255, 255, 255, 0.9)',
        customClass: {
          title: 'my-title-font',
          htmlContainer: 'my-text-font',
          confirmButton: 'my-button-font'
        },
        didOpen: () => {
          const popup = Swal.getPopup();
          popup.style.setProperty('--swal2-font-family', 'IRANSans', 'important');
          popup.querySelector('.swal2-title').style.fontFamily = 'IRANSans';
          popup.querySelector('.swal2-html-container').style.fontFamily = 'IRANSans';
          popup.querySelector('.swal2-confirm').style.fontFamily = 'IRANSans';
        }

      });

    },
    deleteNotify(title, message) {
      let title_text = "حذف مـوفق"
      let text = "حذف با موفقیت انجام شد"
      if (title) {
        title_text = title
      }
      if (message) {
        text = message
      }
      Swal.fire({
        title: title_text,
        text: text,
        icon: "success",
        confirmButtonText: "ادامه",
        confirmButtonColor: '#8f040e',
        background: 'rgba(237, 9, 55, 0.7)',
        color: '#fff',
        width: '32rem',
        iconColor: 'rgba(255, 255, 255, 0.9)',
        customClass: {
          title: 'my-title-font',
          htmlContainer: 'my-text-font',
          confirmButton: 'my-button-font'
        },
        didOpen: () => {
          const popup = Swal.getPopup();
          popup.style.setProperty('--swal2-font-family', 'IRANSans', 'important');
          popup.querySelector('.swal2-title').style.fontFamily = 'IRANSans';
          popup.querySelector('.swal2-html-container').style.fontFamily = 'IRANSans';
          popup.querySelector('.swal2-confirm').style.fontFamily = 'IRANSans';
        }

      });

    },
    notify(msg, type) {
      let colors = {
        'danger': 'error',
        'warning': 'primary',
        'success': 'success'
      }
      this.$store.commit('setSnackbar', {
        show: true,
        color: colors[type],
        text: msg
      });
    },
    openErrorDialog(options) {
      options.show = true;
      this.$store.commit('setErrorDialog', options);
    },
    hasPerm(operation = '', basename = '', object = null) {
      let user = this.$store.state.user
      if (user.is_superuser) return true
      if (this.company && user.id == this.company.superuser) return true

      let roles = user.roles.filter(o => this.company && o.company == this.company.id);
      for (let role of roles) {
        for (let permission of role.permissions) {
          let codename = permission.codename.split('.')
          if (codename[0].startsWith(operation) && codename[1].startsWith(basename)) {
            if (object && codename.includes('Own')) {
              if (object.created_by == user.id) {
                return true
              } else {
                return false
              }
            } else {
              return true
            }
          }
        }
      }
      return false
    },
    hasModule(moduleName) {
      return this.user && this.company.modules.includes(moduleName);
    },
    hasFeature(featureName) {
      return this.user && this.company.features.includes(featureName);
    },
    hasExtension(extensionId) {
      return this.user && this.company.extensions.includes(extensionId);
    },
    goTo(selector) {
      $('body,html')
        .scrollTop($(selector)
          .offset()
          .top - $('selector')
            .height() - 50);
    },
    setToken(token) {
      localStorage.setItem('token', token);
      this.token = token;
    },
    copy(obj) {
      let res = null;
      if (Array.isArray(obj)) {
        res = obj.slice();
      } else {
        res = Object.assign({}, obj);
      }
      return res;
    },
    log(t) {
      console.log(moment().format('HH:mm:ss:SS'), t);
    },
    openFactor(factor) {
      let routeData = this.$router.resolve({
        name: "FactorForm",
        params: {
          isPreFactor: factor.is_pre_factor,
          type: factor.type,
          id: factor.id
        }
      });
      window.open(routeData.href, "_blank");
    },
    hasValue(v) {
      return !['', 0, '0', undefined, null].includes(v);
    },
    toGDate(date) {
      let gDate = null;
      if (date) {
        const momentDate = moment(date, "jYYYY/jMM/jDD", true);
        if (momentDate.isValid()) {
          gDate = momentDate.format(
            "YYYY-MM-DD"
          );
        }
      }
      return gDate;
    },
    toJDate(date) {
      let jDate = null;
      if (date) {
        const momentDate = moment(date, "YYYY-MM-DD", true);
        if (momentDate.isValid()) {
          jDate = momentDate.format(
            "jYYYY/jMM/jDD"
          );
        } else {
          return date
        }
      }
      return jDate;
    },
    toMoney(value) {

      let isNegative = false;
      if (!value) value = "";
      else {
        let numeric_value = Number(value);
        if (numeric_value < 0) {
          isNegative = true;
          numeric_value = -numeric_value
        }
        if (!isNaN(numeric_value)) value = String(numeric_value);
        else value = String(value);
      }

      value = value.split(",").join("");

      let formattedValue = value
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      if (isNegative) {
        return `-${formattedValue}`;
      } else {
        return formattedValue
      }
    },
    todayDate() {
      return moment().format('jYYYY/jMM/jDD');
    },
    getRandomId() {
      return 'rid-' + Math.floor(Math.random() * 10000)
    },
    updateQueryString(key, value) {
      let route = this.$route;

      let query = {
        ...route.query
      };
      query[key] = value

      this.$router.push({
        name: route.name,
        params: route.params,
        query: query
      })
    },

    getVariable(variable) {
      return this[variable]
    },
    setVariable(variable, value) {
      this[variable] = value
    }
  },
  filters: {
    toJalali(date, format = 'jYYYY/jMM/jDD') {
      if (date) { return moment(date).format(format); }
      else { return '-' }

    },
    toMoney(value, decimalScale = 4) {

      let isNegative = false;
      if (value == null || value == undefined) value = "-";
      else {
        let numeric_value = Number(value);
        numeric_value = Number(numeric_value.toFixed(decimalScale));
        if (numeric_value < 0) {
          isNegative = true;
          numeric_value = -numeric_value
        }
        if (!isNaN(numeric_value)) value = numeric_value.toString();
        else value = String(value);
      }

      value = value.split(",").join("");

      let formattedValue = value
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      if (isNegative) {
        return `-${formattedValue}`;
      } else {
        return formattedValue
      }
    },
    toInt(value) {
      return parseInt(value)
    },
    toAbs(value) {
      return Math.abs(value)
    },
  }
})